import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAdminSearch } from '../../shared/useAdminSearch';
import { useUserSearchOptions } from '../../shared/useUserSearchOptions';
import { AdminDataGrid } from '../../shared/AdminDataGrid';
import { AdminExportButton } from '../../shared/AdminExportButton';
import { useListAllUsersQuery } from '../api/usersApi';
import { DEFAULT_HIDDEN_USER_COLUMNS, userColumns } from './columns';
import { useUserFilter } from './useUserFilter';

/**
 * The admin users grid. Loads every user, then filters (filters, from the page's toolbar),
 * searches (by id, name, email, phone, delegated emails and broker group names), sorts and
 * pages them in the browser. With a search and no column sort, rows are in relevance order.
 * Export downloads the current results. Clicking a row opens its edit drawer (the :userId
 * route), keeping the page's search.
 *
 * @param {object} props
 * @param {string} props.search from useAdminListParams
 * @param {object} props.filters from useAdminListParams
 * @param {object} props.gridProps from useAdminListParams
 */
export const UsersTable = ({ search, filters, gridProps }) => {
	const navigate = useNavigate();
	const { search: locationSearch } = useLocation();
	const { data: users = [], isLoading, isError } = useListAllUsersQuery();
	const filteredUsers = useUserFilter(users, filters);
	const rows = useAdminSearch(filteredUsers, useUserSearchOptions(), search);

	return (
		<AdminDataGrid
			table='users'
			columns={userColumns}
			defaultHiddenColumns={DEFAULT_HIDDEN_USER_COLUMNS}
			rows={rows}
			isLoading={isLoading}
			isError={isError}
			objectType='users'
			toolbarActions={<AdminExportButton fileName='Users' />}
			{...gridProps}
			onRowClick={({ id }) => navigate({ pathname: id, search: locationSearch })}
		/>
	);
};
